import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './QuoteModal.css';

interface QuoteData {
  serviceId?: number;
  title: string;
  description: string;
  price: number;
  deliveryDays: number;
  revisions: number;
  createdAt: string;
}

interface QuoteMessageProps {
  messageId: number;
  quoteData: QuoteData;
  quoteStatus: 'pending' | 'accepted' | 'rejected' | 'expired';
  isMyMessage: boolean;
  isClient: boolean; // 현재 사용자가 의뢰자인지
  onAccept: (messageId: number) => void;
  onReject: (messageId: number) => void;
  orderId?: number; // 수락된 경우 주문 ID
}

const QuoteMessage: React.FC<QuoteMessageProps> = ({
  messageId,
  quoteData,
  quoteStatus,
  isMyMessage,
  isClient,
  onAccept,
  onReject,
  orderId
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handlePayment = () => {
    if (orderId) {
      navigate(`/payment?orderId=${orderId}&amount=${quoteData.price}&orderName=${encodeURIComponent(quoteData.title)}`);
    }
  };

  return (
    <div className={`quote-message-card ${isMyMessage ? 'my-quote' : ''}`}>
      <div className="quote-header">
        <span>💰</span>
        <h4>{t('quoteMsg.title')}</h4>
      </div>
      
      <div className="quote-title">{quoteData.title}</div>
      
      {quoteData.description && (
        <div className="quote-desc">{quoteData.description}</div>
      )}
      
      <div className="quote-details">
        <div className="quote-detail-item">
          <span className="label">{t('quoteModal.price')}</span>
          <span className="value">{t('projects.budgetExact', { v: quoteData.price.toLocaleString() })}</span>
        </div>
        <div className="quote-detail-item">
          <span className="label">{t('quoteModal.days')}</span>
          <span className="value">{t('projectDetail.daysN', { n: quoteData.deliveryDays })}</span>
        </div>
        <div className="quote-detail-item">
          <span className="label">{t('serviceDetail.revisions')}</span>
          <span className="value">{t('serviceDetail.timesN', { n: quoteData.revisions })}</span>
        </div>
      </div>

      {quoteStatus === 'pending' && isClient && !isMyMessage && (
        <div className="quote-actions">
          <button className="reject-btn" onClick={() => onReject(messageId)}>
            {t('common.reject')}
          </button>
          <button className="accept-btn" onClick={() => onAccept(messageId)}>
            {t('common.accept')}
          </button>
        </div>
      )}

      {quoteStatus === 'pending' && !isClient && isMyMessage && (
        <div className="quote-status pending">
          ⏳ {t('quoteMsg.waitingClient')}
        </div>
      )}

      {quoteStatus === 'accepted' && (
        <div className="quote-status accepted">
          ✅ {t('chat.accepted')}
          {isClient && orderId && (
            <button 
              onClick={handlePayment}
              style={{
                marginLeft: '10px',
                padding: '6px 12px',
                background: '#4f46e5',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '12px'
              }}
            >
              {t('quoteMsg.pay')}
            </button>
          )}
        </div>
      )}

      {quoteStatus === 'rejected' && (
        <div className="quote-status rejected">
          ❌ {t('chat.rejected')}
        </div>
      )}
    </div>
  );
};

export default QuoteMessage;
